import { render, staticRenderFns } from "./checkTransferVerifyCode.vue?vue&type=template&id=02cb5e4e&scoped=true&"
import script from "./checkTransferVerifyCode.vue?vue&type=script&lang=js&"
export * from "./checkTransferVerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./checkTransferVerifyCode.vue?vue&type=style&index=0&id=02cb5e4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb5e4e",
  null
  
)

export default component.exports